'use client'

import { useState } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { reloadPage } from '@marketplace-web/browser/browser-navigation-util'
import {
  updateShippingDeadlineExtension,
  clickEvent,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { ResponseCode } from '@marketplace-web/core-api/api-client-util'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import CancelShippingDeadlineExtensionModal from './CancelShippingDeadlineExtensionModal'
import { DeadlineExtensionStatus } from '../../constants'

type Props = ConversationActionProps

const CancelShippingDeadlineExtension = ({ primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()

  const { conversation } = useConversationContext()

  const shipmentId = conversation?.transaction?.shipment?.id
  const transactionId = conversation?.transaction?.id

  const [isModalOpen, setIsModalOpen] = useState(false)

  const trackButtonClick = () => {
    if (!transactionId) return

    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        target: 'cancel_shipping_deadline_extension',
        screen: 'message_reply',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  const handleClick = () => {
    trackButtonClick()

    setIsModalOpen(true)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  const cancelExtendShippingDeadline = async () => {
    if (!shipmentId) return

    const response = await updateShippingDeadlineExtension({
      shipmentId,
      status: DeadlineExtensionStatus.Cancelled,
    })

    if (response.code === ResponseCode.Ok) reloadPage()
  }

  return (
    <>
      <ConversationActionButton
        text={title}
        primary={primary}
        size={size}
        theme={theme}
        inverse={inverse}
        onClick={handleClick}
        testId="cancel-shipping-deadline-extension-conversation-action"
      />
      <CancelShippingDeadlineExtensionModal
        isOpen={isModalOpen}
        onSubmit={cancelExtendShippingDeadline}
        onClose={handleModalClose}
      />
    </>
  )
}

export default CancelShippingDeadlineExtension
